import React from 'react';
import { motion } from 'framer-motion';
import { FaHouseUser, FaChartLine, FaUsers, FaTrophy } from 'react-icons/fa';

const stats = [
  { icon: <FaHouseUser size={60} />, label: 'Complete Projects', count: 854 },
  { icon: <FaChartLine size={60} />, label: 'Property Sold', count: 854 },
  { icon: <FaUsers size={60} />, label: 'Happy Clients', count: 854 },
  { icon: <FaTrophy size={60} />, label: 'Awards Won', count: 854 }
];

export default function StatsSection() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4 }}
      className="bg-primary text-white py-5"
    >
      <div className="container">
        <div className="row text-center">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1 * index }}
              className="col-md-6 col-lg-3 mb-3"
            >
              <div className="fs-1 text-warning mb-2">{stat.icon}</div>
              <h3 className='fs-1 fw-bolder mb-0'>{stat.count}</h3>
              <p className='fs-5'>{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
